import * as tslib_1 from "tslib";
import { OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { FcPaginatorComponent } from '@core/components/fc-paginator/fc-paginator.component';
import { Subject } from 'rxjs';
import { debounceTime, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { GroupService } from '../../../services/groups-api.service';
import { LinkLocationsComponent } from './link-locations/link-locations.component';
var TabLocationsComponent = /** @class */ (function () {
    function TabLocationsComponent(matDialog, groupService) {
        this.matDialog = matDialog;
        this.groupService = groupService;
        this.searchInput = new FormControl('');
        this.page = null;
        this.isSearching = false;
        this.pageSize = 5;
        this.currentPage = 0;
        this.isLoading = true;
        this.isPageChanging = false;
        this.removeSubscriptions = new Subject();
        this.reload = new Subject();
    }
    TabLocationsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchInput.valueChanges.pipe(debounceTime(500)).subscribe(function () {
            _this.isLoading = true;
            if (_this.paginator) {
                _this.paginator.firstPage();
            }
            else {
                _this.reload.next();
            }
        });
        this.reload.pipe(takeUntil(this.removeSubscriptions), tap(function () { return _this.isLoading = true; }), switchMap(function () { return _this.searchLocations(); }), tap(function () {
            _this.isLoading = false;
        })).subscribe(function (locationPage) {
            _this.page = locationPage;
        });
        this.reload.next();
    };
    TabLocationsComponent.prototype.ngOnChanges = function (changes) {
        if (changes.group) {
            this.reload.next();
        }
    };
    TabLocationsComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    TabLocationsComponent.prototype.openLinkLocationsDialog = function () {
        var _this = this;
        this.matDialog
            .open(LinkLocationsComponent, {
            panelClass: ['dialog-groups'],
            data: {
                group: this.group,
            },
        })
            .beforeClosed()
            .pipe(filter(function (result) { return result && result.reload; }))
            .subscribe(function () {
            _this.reload.next();
        });
    };
    TabLocationsComponent.prototype.searchLocations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.group.id) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, this.groupService.listLocations({
                        groupId: this.group.id,
                        limit: this.pageSize,
                        offset: this.currentPage * this.pageSize,
                        where: {
                            formattedAddressOrDocumentNumber_contains: this.searchInput.value || '',
                            groupId_in: [this.group.id]
                        }
                    })];
            });
        });
    };
    TabLocationsComponent.prototype.removeLocationFroGroup = function (location) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        location['isSaving'] = true;
                        return [4 /*yield*/, this.groupService.removeLocationFromGroup([
                                {
                                    locationId: location.id,
                                    groupId: this.group.id
                                }
                            ])];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.searchLocations()];
                    case 2:
                        _a.page = _b.sent();
                        location['isSaving'] = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TabLocationsComponent.prototype.onPageChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.currentPage = event.pageIndex;
                        this.isPageChanging = true;
                        _a = this;
                        return [4 /*yield*/, this.searchLocations()];
                    case 1:
                        _a.page = _b.sent();
                        this.isPageChanging = false;
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return TabLocationsComponent;
}());
export { TabLocationsComponent };
